import { render, staticRenderFns } from "./perfilExpander.vue?vue&type=template&id=11a0e3b3"
import script from "./perfilExpander.vue?vue&type=script&lang=js"
export * from "./perfilExpander.vue?vue&type=script&lang=js"
import style0 from "./perfilExpander.vue?vue&type=style&index=0&id=11a0e3b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports